import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID, TransferState } from '@angular/core';
import { BrandConfigurationService } from '../configuration/brand-configuration.service';
import { ScriptLoaderService } from '../script-loader/script-loader.service';
import { ServerTrustpilotService } from './server-trustpilot.service';

@Injectable({
  providedIn: 'root',
})
export class TrustpilotService extends ServerTrustpilotService {
  constructor(
    public sls_: ScriptLoaderService,
    public bfs_: BrandConfigurationService,
    state: TransferState,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    super(sls_, bfs_, state);
  }

  loadTrustpilot = (container: any) => {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(({ isIntersecting }) => {
        if (isIntersecting) {
          this.sls_.injectScriptByType('trustpilot');
        }
      });
    });
    obs.observe(container.nativeElement);
  };

  openTrustpilot(trustpilotBrandUrl: string): void {
    const trustpilotWidget = this.document.querySelector('trustpilot');

    if (trustpilotWidget) {
      trustpilotWidget.scrollIntoView({ behavior: 'smooth' });
    } else if (isPlatformBrowser(this.platformId)) {
      window.open(trustpilotBrandUrl, '_blank');
    }
  }
}
